




import { Component, Prop, Vue } from 'vue-property-decorator'
import { MASTER_ROLE } from '@/class/const'
import { RoleId } from '@/enum'

@Component
export default class Card extends Vue {
  @Prop() roleId!: RoleId;

  get imageSorce () {
    if (!this.roleId) {
      return require(`@/assets/card/back.jpg`)
    }

    return require(`@/assets/card/${MASTER_ROLE[this.roleId].imageId}.jpg`)
  }
}
